import NextImage from 'next/image'
import { isNil } from 'ramda'

import { getStrapiMedia } from '../../utils/media'

type ImageType = {
  alternativeText?: string
  className?: string
  url?: string
  height?: number
  mime?: string
  width?: number
}

export const StrapiMedia = ({
  alternativeText,
  className,
  url,
  height,
  mime,
  width,
}: ImageType) => {
  const src = getStrapiMedia(url)

  if (!isNil(mime) && mime.includes('video')) {
    return (
      <video
        autoPlay
        disablePictureInPicture
        loop
        muted
        playsInline
        className={className}
      >
        <source src={src} type={mime} />
      </video>
    )
  }

  return (
    <NextImage
      alt={alternativeText ?? ''}
      className={className}
      height={height ?? ('100%' as unknown as number)}
      src={src}
      width={width ?? ('100%' as unknown as number)}
    />
  )
}
